// extracted by mini-css-extract-plugin
export default {"operation":"style_operation__zjUbS"};